import React, { Component } from 'react';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { connect } from 'react-redux';
import $ from "jquery";
import '../../css/tablesPOS.css';
import { ApiClient } from "../../libs/apiClient";
import { Modules } from '../../libs/utils/Const';
import { GeneralFunctions, ReportAccountStatusModal, ReportProdOpenDocs, ReportProductionTree } from "../../components/index";
import {
    NavBar,
    BreadCumb,
    TimeOut,
    ReportSalesModal,
    ReportSalesSellerModal,
    ReportPurchasingModal,
    ReportStocksModal,
    ReportOperationsModal,
    ReportKardexModal,
    ReportItemsSoldsModal,
    ReportCollectModal,
    ReportReserveInvoiceModal,
    ReportGlobalInvoiceDeliveryModal,
    ReportReturnCNoteModal,
    ReportCard,
    ReportCreditWalletModal,
    ReportCierreCajaModal,
    ReportContrasteCobranzaModal,
    ReportEstatusFacturasModal,
} from '../../components';
import config from "../../config";
import { ReportsModel } from '../../components/NewOrder';
import moment from 'moment';
const _generalFunctions = new GeneralFunctions();
let apiClient = ApiClient.getInstance();

class ReportSalesView extends Component {

    constructor(props) {
        super(props);

        this.state = {
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            ReportsModel: new ReportsModel(),
            ShowReportSalesModal: false,
            ActualDate: moment(new Date()).format('YYYY-MM-DD'),
            ListUsers: [],
            ListReports: [],
            ShowPDFViewerModal: false,
            ListWhsCodes: [],
            ShowReportStocksModal: false,
            ListItmsGrpCod: [],
            ListEmployee: [],
            ListProjects: [],
            wareHouses: [],
            ShowReportCollectModal: false,
            ShowReportKardexModal: false,
            ShowReportOperationsModal: false,
            ShowReportSalesSellerModal: false,
            ShowReportItemsSoldsModal: false,
            ShowReportPurchasingModal: false,
            ShowReportReserveInvoiceModal: false,
            partners: [],
            items: [],
            pageTotal: 0,
            AvailablePayments: [],
            checkboxLines: true,
            checkboxVendor: true,
            TypeDoc: '',
            sendMailModel: {
                to: '',
                subject: '',
                docEntry: ''
            },
            sellersByBO: [],
            sellerBO_ID: '',
            sucursales: [],
            printhide: true,
            // Suggestion Catalogs
            suggestionCatalogs: {
                businessPartnerCCatalog: [],
                salesPersonCatalog: [],
                groupNumCatalog: [],
            },

            // Reportes nuevos
            ShowGlobalInvoiceDeliveryReport: false,
            ShowReportReturnCNotes: false,
            showCreditWallet: false,
            showAccountStatus: false,
            ShowReportCierreCajaModal: false,
            ShowReportContrasteCobranzaModal: false,
            ShowReportEstatusFacturasModal: false,
        }
    }

    componentDidMount = async () => {
        await this.getCreditWalletCatalogs();
        await this.SetPayments();
    }

    getCreditWalletCatalogs = async () => {
        const { enableSpinner } = this.props

        enableSpinner(true);
        let creditWalletCatalogs = await apiClient.getSuggestionCatalogs({ businessPartnerC: true, salesPerson: true, groupNum: true });
        creditWalletCatalogs = creditWalletCatalogs.data;
        enableSpinner(false);

        if (!!creditWalletCatalogs) {
            let suggestionCatalogs = {
                ...this.state.suggestionCatalogs,
                businessPartnerCCatalog: creditWalletCatalogs.businessPartnerC,
                salesPersonCatalog: creditWalletCatalogs.salesPerson,
                groupNumCatalog: creditWalletCatalogs.groupNum,
            };

            await this.setState({ suggestionCatalogs });
        }
    }

    SetPayments = async () => {
        const { enableSpinner } = this.props;
        const { _user } = this.state;
        const data = { data: false };
        enableSpinner(true);
        let listsucursales = await apiClient.getSucursales(data);
        enableSpinner(false);
        await this.setState({
            AvailablePayments: _user?.Branch.PaymentMethods || [],
            sucursales: listsucursales.data
        })

    }

    RefreshModel = ReportsModel => {
        this.setState({
            ReportsModel
        })
    };

    ChangeClient = event => {
        const { ReportsModel } = this.state;

        ReportsModel.CardCode = event.nativeEvent.target.value;
        this.RefreshModel(ReportsModel);
    };

    OpenReportSalesModal = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state
        const data = {
            codeBO: _user?.Branch.CodeBranchOffice,
        }
        enableSpinner(true);
        const responseUsers = await apiClient.getSellersByBO(data);
        enableSpinner(false);

        if (responseUsers.status !== 1) {
            showAlert({ type: "error", message: `${responseUsers.message}` });
            return;
        }


        await this.setState({
            ListUsers: responseUsers.data || [],
            ShowReportSalesModal: !this.state.ShowReportSalesModal
        });
        $("#reportSalesModal").modal("show");
    };

    ChangeInitialDate = event => {
        const { ReportsModel } = this.state;
        ReportsModel.InitialDate = event.nativeEvent.target.value;
        this.RefreshModel(ReportsModel);
    };

    ChangeFinalDate = event => {
        const { ReportsModel } = this.state;
        ReportsModel.FinalDate = event.nativeEvent.target.value;
        this.RefreshModel(ReportsModel);
    };

    ChangeStatus = async (event) => {
        const { ReportsModel } = this.state;
        ReportsModel.Status = event.nativeEvent.target.value;
        this.RefreshModel(ReportsModel);
    };

    ChangeUser = async (event, flag = false) => {
        const { ReportsModel } = this.state;
        ReportsModel.User = event.nativeEvent.target.value;
        this.RefreshModel(ReportsModel);
        if (flag) await this.ChangeUserName(ReportsModel.User);
    };

    ChangeUserName = (value) => {
        const { ReportsModel, sellersByBO } = this.state;

        const foundSeller = sellersByBO.find(seller => Number(seller.USERID) === Number(value));
        if (foundSeller) {
            ReportsModel.UserName = foundSeller.U_NAME ?? '';
        }


        this.RefreshModel(ReportsModel);
    }

    ChangeType = event => {
        const { ReportsModel } = this.state;

        ReportsModel.Type = event.nativeEvent.target.value;
        this.RefreshModel(ReportsModel);
    };

    ChangeViewEntries = () => {
        const { ReportsModel } = this.state;
        ReportsModel.checkViewEntries = !ReportsModel.checkViewEntries;
        this.RefreshModel(ReportsModel);
    };

    ChangeBill = () => {
        const { ReportsModel } = this.state;

        ReportsModel.checkBill = !ReportsModel.checkBill;
        this.RefreshModel(ReportsModel);
    };

    ChangeCashNotes = () => {
        const { ReportsModel } = this.state;

        ReportsModel.checkCashNotes = !ReportsModel.checkCashNotes;
        this.RefreshModel(ReportsModel);
    };

    ChangeCreditNotes = () => {
        const { ReportsModel } = this.state;

        ReportsModel.checkCreditNotes = !ReportsModel.checkCreditNotes;
        this.RefreshModel(ReportsModel);
    };

    ChangeRefounds = () => {
        const { ReportsModel } = this.state;
        ReportsModel.checkRefounds = !ReportsModel.checkRefounds;
        this.RefreshModel(ReportsModel);
    };

    ChangeDirectDeliveries = () => {
        const { ReportsModel } = this.state;

        ReportsModel.checkDirectDeliveries = !ReportsModel.checkDirectDeliveries;
        this.RefreshModel(ReportsModel);
    };

    ChangeReturn = () => {
        const { ReportsModel } = this.state;
        ReportsModel.checkReturn = !ReportsModel.checkReturn;
        this.RefreshModel(ReportsModel);
    };

    ChangeCNote = () => {
        const { ReportsModel } = this.state;
        ReportsModel.checkCreditNote = !ReportsModel.checkCreditNote;
        this.RefreshModel(ReportsModel);
    };

    GenerateReport = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel } = this.state;

        if (ReportsModel.checkBill || ReportsModel.checkCashNotes || ReportsModel.checkCreditNotes || ReportsModel.checkRefounds || ReportsModel.checkDirectDeliveries) {
            enableSpinner(true);
            const data = {
                ReportsModel,
            }
            let responseGenerateReports = await apiClient.GenerateReports(data);

            if (responseGenerateReports.status !== 1) {
                showAlert({ type: "error", message: `${responseGenerateReports.message}` });
                enableSpinner(false);
                return;
            }

            if (!responseGenerateReports.data.flagResults) {
                showAlert({ type: "info", message: 'No se encontró información' });
                enableSpinner(false);
                return;
            }

            enableSpinner(false);
            await this.setState({
                ListReports: [responseGenerateReports.data] || [],
                ShowPDFViewerModal: !this.state.ShowPDFViewerModal
            });

            $("#pdfViewer").modal("show");
        } else {
            showAlert({ type: "info", message: 'Selecciona un tipo de operación' });
            return;
        }
    };

    ShowPDFViewer = async () => {
        await this.setState({
            ShowPDFViewerModal: false,
            ReportsModel: new ReportsModel(),
            checkboxLines: true,
            checkboxVendor: true,
        });

        setTimeout(() => {
            if (this.state.ShowReportEstatusFacturasModal && !$('#reportEstatusFacturasModal').hasClass('show')) {
                $('#reportEstatusFacturasModal').modal('show');
            }

            setTimeout(() => {
                if ($('.modal:visible').length === 0 && $('.modal-backdrop').length > 0) {
                    $('.modal-backdrop').remove();
                    $('body').removeClass('modal-open').css('padding-right', '');
                }
            }, 350);
        }, 300);
    };

    OpenReportStockModal = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        const availableProjects = await apiClient.getProjectsList();
        const wareHouses = await apiClient.getWhsCodes();
        const GroupsItemData = await apiClient.getGroupsItemData();
        enableSpinner(false);
        // if (availableProjects.status !== 1) {
        //     showAlert({ type: "error", message: `Error al consultar los almacenes (Proyectos). Intente cerrando y abriendo la ventana del mismo reporte.` });
        // }
        if (wareHouses.status !== 1) {
            showAlert({ type: "error", message: `Error al consultar los almacenes. Intente cerrando y abriendo la ventana del mismo reporte.` });
        }
        if (GroupsItemData?.status !== 1) {
            showAlert({ type: "error", message: `Error al consultar las lineas disponibles. Intente cerrando y abriendo la ventana del mismo reporte.` });
        }

        await this.setState({
            ListProjects: availableProjects?.data || [],
            wareHouses: wareHouses?.data ?? [],
            ListItmsGrpCod: GroupsItemData?.data?.GrupoArticulo || [],
            ShowReportStocksModal: !this.state.ShowReportStocksModal
        });
        $("#reportStocksModal").modal("show");
    };

    ChangeWhsCode = event => {
        const { ReportsModel } = this.state;

        let separador = event.nativeEvent.target.value.split('|');

        ReportsModel.WhsCode = event.nativeEvent.target.value;
        ReportsModel.WhsName = separador[1] || '';
        this.RefreshModel(ReportsModel);
    };

    ChangeWhsCodeBySelect = (option) => {
        const { ReportsModel } = this.state;

        if (!option) {
            ReportsModel.WhsCode = '';
            ReportsModel.WhsName = '';
            this.RefreshModel(ReportsModel);
            return;
        }

        ReportsModel.WhsCode = option?.value;
        ReportsModel.WhsName = option?.WhsName || '';

        this.RefreshModel(ReportsModel);
    };

    ChangeFilter = event => {
        const { ReportsModel } = this.state;

        ReportsModel.Filter = event.nativeEvent.target.value;
        this.RefreshModel(ReportsModel);
    };

    ChangeLine = event => {
        const { ReportsModel } = this.state;

        ReportsModel.Line = event.nativeEvent.target.value;
        this.RefreshModel(ReportsModel);
    };

    ChangeCheckExistDate = () => {
        const { ReportsModel } = this.state;

        ReportsModel.checkExistDate = !ReportsModel.checkExistDate;
        this.RefreshModel(ReportsModel);
    };

    ChangeCheckExistNegative = () => {
        const { ReportsModel } = this.state;
        ReportsModel.checkExistNegative = !ReportsModel.checkExistNegative;

        if (ReportsModel.checkExist) ReportsModel.checkExist = !ReportsModel.checkExist;
        this.RefreshModel(ReportsModel);
    };

    ChangeCheckInformationBatch = () => {
        const { ReportsModel } = this.state;

        ReportsModel.checkInformationBatch = !ReportsModel.checkInformationBatch;
        this.RefreshModel(ReportsModel);
    };

    ChangeCheckExist = () => {
        const { ReportsModel } = this.state;
        ReportsModel.checkExist = !ReportsModel.checkExist;
        if (ReportsModel.checkExistNegative) ReportsModel.checkExistNegative = !ReportsModel.checkExistNegative;
        this.RefreshModel(ReportsModel);
    };

    ChangeSupplierEntries = () => {
        const { ReportsModel } = this.state;
        ReportsModel.supplierEntries = !ReportsModel.supplierEntries;
        this.RefreshModel(ReportsModel);
    }

    ChangeSupplierInvoices = () => {
        const { ReportsModel } = this.state;
        ReportsModel.supplierInvoices = !ReportsModel.supplierInvoices;
        this.RefreshModel(ReportsModel);
    }

    ChangeSupplierReturns = () => {
        const { ReportsModel } = this.state;
        ReportsModel.supplierReturns = !ReportsModel.supplierReturns;
        this.RefreshModel(ReportsModel);
    }

    ChangeSupplierCreditNotes = () => {
        const { ReportsModel } = this.state;
        ReportsModel.supplierCreditNotes = !ReportsModel.supplierCreditNotes;
        this.RefreshModel(ReportsModel);
    }

    ChangeSupplierDocPayCondition = (value) => {
        const { ReportsModel } = this.state;
        ReportsModel.supplierCreditNotes = value;
        this.RefreshModel(ReportsModel);

    }

    OpenReportCollect = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);

        // let whscode = await apiClient.getWhsCodes();

        // if (whscode.status !== 1) {
        //     showAlert({ type: "error", message: `${whscode.message}` });
        //     return;
        // }
        enableSpinner(false);
        await this.setState({
            ShowReportCollectModal: !this.state.ShowReportCollectModal
        });
        $("#reportCollectModal").modal("show");
    };

    OpenReportKardex = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);

        let whscode = await apiClient.getWhsCodes();

        if (whscode.status !== 1) {
            showAlert({ type: "error", message: `${whscode.message}` });
            return;
        }

        enableSpinner(false);
        await this.setState({
            ListWhsCodes: whscode.data || [],
            ShowReportKardexModal: !this.state.ShowReportKardexModal
        });
        $("#reportKardexModal").modal("show");
    };

    ChangeItemCode = event => {
        const { ReportsModel } = this.state;

        if (event.nativeEvent.data !== '') {
            ReportsModel.searchItem = event.nativeEvent.target.value.trim();
            ReportsModel.ItemCode = event.nativeEvent.target.value.trim();
            ReportsModel.ItemName = '';
        }
        this.RefreshModel(ReportsModel);
    };

    OpenReportOperations = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel } = this.state;
        enableSpinner(true);

        let GroupsItemData = await apiClient.getGroupsItemData();
        let getEmployee = await apiClient.getEmployeeList();
        if (GroupsItemData.status !== 1) {
            showAlert({ type: "error", message: `${GroupsItemData.message}` });
            return;
        }
        if (getEmployee.status !== 1) {
            showAlert({ type: "error", message: `${getEmployee.message}` });
            return;
        }

        for (let index = 0; index < GroupsItemData.data.GrupoArticulo.length; index++) {
            const element = GroupsItemData.data.GrupoArticulo[index];
            element.selected = true;
        }
        for (let index = 0; index < getEmployee.data.length; index++) {
            const element = getEmployee.data[index];
            element.selected = true;
        }

        ReportsModel.Condition = '<=';
        this.RefreshModel(ReportsModel);
        enableSpinner(false);
        await this.setState({
            ListItmsGrpCod: GroupsItemData.data.GrupoArticulo || [],
            ListEmployee: getEmployee.data || [],
            ShowReportOperationsModal: !this.state.ShowReportOperationsModal
        });
        $("#reportOperationsModal").modal("show");
    };

    OpenReportSalesSeller = async () => {
        const { ReportsModel } = this.state

        await this.setState({

            ShowReportSalesSellerModal: !this.state.ShowReportSalesSellerModal
        });
        $("#reportSalesSellerModal").modal("show");
    };

    OpenReportReserveInvoiceModal = async () => {
        await this.setState({
            ShowReportReserveInvoiceModal: !this.state.ShowReportReserveInvoiceModal
        });
        $("#reportReserveInvoiceModal").modal("show");
    };

    OpenGlobalInvoiceDeliveryReport = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state
        // const data = {
        //     codeBO: _user?.Branch.CodeBranchOffice,
        // }
        // enableSpinner(true);
        // const responseUsers = await apiClient.getSellersByBO(data);
        // enableSpinner(false);        

        // if (responseUsers.status !== 1) {
        //     showAlert({ type: "error", message: `${responseUsers.message}` });
        //     return;
        // }


        await this.setState({
            // ListUsers: responseUsers.data || [],
            ShowGlobalInvoiceDeliveryReport: !this.state.ShowGlobalInvoiceDeliveryReport
        });
        $("#globalInvoiceDeliveryModal").modal("show");
    };

    OpenReportReturnCNote = async () => {
        await this.setState({
            ShowReportReturnCNotes: !this.state.ShowReportReturnCNotes
        });
        $("#ReportReturnCNoteModal").modal("show");
    };

    openReportCreditWallet = async () => {
        await this.setState({ showCreditWallet: true });
        $("#ReportCreditWallet").modal("show");
        $("#ReportCreditWallet").on("hidden.bs.modal", async () => {
            await this.setState({ showCreditWallet: false });
        });
    }

    openReportAccountStatus = async () => {
        await this.setState({ showAccountStatus: true });
        $("#ReportAccountStatus").modal("show");
        $("#ReportAccountStatus").on("hidden.bs.modal", async () => {
            await this.setState({ showAccountStatus: false });
        });
    }

    openProductionTree = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        enableSpinner(true);
        const GroupsItemData = await apiClient.getGroupsItemData();
        enableSpinner(false);
        if (!GroupsItemData.status) {
            showAlert({ type: "error", message: `Error la consultar las lineas disponibles. Intente cerrando y abriendo la ventana del mismo reporte.` });
        }

        await this.setState({
            showProductionTree: true,
            ListItmsGrpCod: GroupsItemData.data.GrupoArticulo || [],
        });
        $("#ReportProductionTree").modal("show");
        $("#ReportProductionTree").on("hidden.bs.modal", async () => {
            await this.setState({
                showProductionTree: false,
                ListItmsGrpCod: [],
            });
        });
    }

    openProdOpenDocs = async () => {
        await this.setState({ showProdOpenDocs: true });
        $("#ReportProdOpenDocs").modal("show");
        $("#ReportProdOpenDocs").on("hidden.bs.modal", async () => {
            await this.setState({ showProdOpenDocs: false });
        });
    }

    // Funcion para traer 4 tipos de reporte, Global Facturas/Entrega y Devoluciones/Notas de credito
    GenerateReportGlobalInvoiceDelivery = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel } = this.state;

        if (ReportsModel.checkBill || ReportsModel.checkDirectDeliveries || ReportsModel.checkReturn || ReportsModel.checkCreditNote) {
            if (ReportsModel.Sucursal === '---') {
                showAlert({ type: "info", message: 'Selecciona una Sucursal' });
                return;
            }
            enableSpinner(true);
            let data = {
                ReportsModel,
            }
            let responseGenerateReports = await apiClient.GlobalInvoiceDelivery(data);

            if (responseGenerateReports.status !== 1) {
                showAlert({ type: "error", message: `${responseGenerateReports.message}` });
                enableSpinner(false);
                return;
            }

            if (!responseGenerateReports.data.flagResults) {
                showAlert({ type: "info", message: 'No se encontró información' });
                enableSpinner(false);
                return;
            }

            enableSpinner(false);
            await this.setState({
                ListReports: [responseGenerateReports.data] || [],
                ShowPDFViewerModal: !this.state.ShowPDFViewerModal
            });

            $("#pdfViewer").modal("show");
        } else {
            showAlert({ type: "info", message: 'Selecciona un tipo de operación' });
            return;
        }
    };

    //#region NEW REPORTS
    GenerateCreditWalletReport = async (filters = {}) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel, sucursales, suggestionCatalogs: { businessPartnerCCatalog } } = this.state;

        if (!filters.branchCode || filters.branchCode === "---") return showAlert({ type: "warning", message: "Selecciona un sucursal valida valido" });

        // if(filters.dateStart === "")  return showAlert({ type: "warning", message: "Debe seleccionar la fecha de inicio (Desde)" });
        // if(filters.dateEnd === "")  return showAlert({ type: "warning", message: "Debe seleccionar la fecha de fin (Hasta)" });

        if (filters.cardCode === "---" && filters.businessPartner && filters.businessPartner.trim() !== "") {
            const businessPartner = filters.businessPartner;
            const searchBP = businessPartnerCCatalog.find(({ CardCode, CardName, LicTradNum }) => CardCode === businessPartner || CardName === businessPartner || LicTradNum === businessPartner);
            if (!searchBP) return showAlert({ type: "warning", message: "Selecciona un socio de negocios valido" });
            filters.cardCode = searchBP.CardCode;
        }

        enableSpinner(true);
        let reportResponse = await apiClient.generateCreditWalletReport(filters);
        enableSpinner(false);

        if (reportResponse.status === SERVICE_RESPONSE.SUCCESS) {
            ReportsModel.SucursalName = sucursales?.find(({ project }) => project === filters.branchCode)?.nombre || "---";
            await this.setState({
                ReportsModel,
                ListReports: [reportResponse.data] || [],
                ShowPDFViewerModal: !this.state.ShowPDFViewerModal
            });

            $("#pdfViewer").modal("show");
        } else {
            return showAlert({ type: "info", message: reportResponse.message || "Ocurrio un error inesperado, vuelva a intentarlo en unos minutos" });
        }
    }

    GenerateAccountStatusReport = async (filters = {}) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel, _user, suggestionCatalogs: { businessPartnerCCatalog } } = this.state;

        if (filters.cardCode === "---") {
            const businessPartner = filters.businessPartner || "";
            const searchBP = businessPartnerCCatalog.find(({ CardCode, CardName, LicTradNum }) => CardCode === businessPartner || CardName === businessPartner || LicTradNum === businessPartner);
            if (!searchBP) return showAlert({ type: "warning", message: "Selecciona un socio de negocios valido" });

            filters.cardCode = searchBP.CardCode;
        }

        enableSpinner(true);
        let reportResponse = await apiClient.generateAccountStatusReport(filters);
        enableSpinner(false);

        ReportsModel.user = _user;

        if (reportResponse.status === SERVICE_RESPONSE.SUCCESS) {
            await this.setState({
                ReportsModel,
                ListReports: reportResponse.data || [],
                ShowPDFViewerModal: !this.state.ShowPDFViewerModal
            });

            $("#pdfViewer").modal("show");
        } else {
            return showAlert({ type: "info", message: reportResponse.message || "Ocurrio un error inesperado, vuelva a intentarlo en unos minutos" });
        }
    }

    GenerateReportsProduction = async (filters = {}) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel, _user } = this.state;

        enableSpinner(true);
        let reportResponse = await apiClient.generateProductionReports(filters);
        enableSpinner(false);

        if (!reportResponse.status) {
            return showAlert({ type: "info", message: reportResponse.message || "Ocurrio un error inesperado, vuelva a intentarlo en unos minutos" });
        }

        ReportsModel.user = _user;

        await this.setState({
            ReportsModel,
            ListReports: reportResponse.data || [],
            ShowPDFViewerModal: !this.state.ShowPDFViewerModal
        });

        $("#pdfViewer").modal("show");
    }
    //#endregion

    GetSellersByBOCode = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user, ReportsModel } = this.state
        const data = {
            codeBO: ReportsModel.Sucursal,
        }
        enableSpinner(true);
        const responseSellers = await apiClient.getSellersByBO(data);
        enableSpinner(false);
        if (responseSellers.status !== 1) {
            showAlert({ type: "error", message: `${responseSellers.message}` });
            // return;
        }
        await this.setState({
            sellersByBO: responseSellers.data || [],

        });

    }

    OpenReportItemsSolds = async () => {
        await this.setState({
            ShowReportItemsSoldsModal: !this.state.ShowReportItemsSoldsModal
        });
        $("#reportItemsSoldsModal").modal("show");
    };

    OpenReportPurchasing = async () => {
        await this.setState({
            ShowReportPurchasingModal: !this.state.ShowReportPurchasingModal
        });
        $("#reportPurchasingModal").modal("show");
    };

    OpenPartnerModal = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel } = this.state;

        let CardCode = ReportsModel.CardCode !== '' ? ReportsModel.CardCode : null;

        enableSpinner(true);

        let getPartnerResponse = await apiClient.getPartner('C', CardCode);

        enableSpinner(false);

        if (getPartnerResponse.data.length === 0) {

            if (!Array.isArray(getPartnerResponse.data.results)) {
                showAlert({ type: 'info', message: getPartnerResponse.message });
                ReportsModel.CardCode = '';
                ReportsModel.CardName = '';
                this.RefreshModel(ReportsModel);
                return;
            }

            if (getPartnerResponse.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
        }
        if (getPartnerResponse.data.length === 1) {
            showAlert({ type: 'success', message: 'Si se encontró el socio de negocios' });
            ReportsModel.CardCode = getPartnerResponse.data[0].CardCode;
            ReportsModel.CardName = getPartnerResponse.data[0].CardName;
            this.RefreshModel(ReportsModel);
        } else {
            await this.setState({
                partners: getPartnerResponse.data.results,
                pageTotal: getPartnerResponse.data.totalPage,
            });

            $('#partnerCreate').modal('show');
        }
    };

    SelectPartner = async action => {
        const { partners, ReportsModel } = this.state;
        let partner = partners[action.index];

        ReportsModel.CardCode = partner.CardCode;
        ReportsModel.CardName = partner.CardName;

        $('#partnerCreate').modal('hide');

        this.RefreshModel(ReportsModel);
    }

    RefreshPartner = async (partner, totalPage) => {
        await this.setState({
            partners: partner,
            pageTotal: totalPage
        });
    }

    OpenItems = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel } = this.state;
        let ItemCode = ReportsModel.ItemCode;

        let getItemResponse = null;

        enableSpinner(true);

        getItemResponse = await apiClient.getItem(ReportsModel.CardCode, 'transfersRequest', ItemCode);

        enableSpinner(false);
        if (getItemResponse.data.length === 0) {

            if (!Array.isArray(getItemResponse.data.results)) {
                showAlert({ type: 'info', message: getItemResponse.message });
                return;
            }

            if (getItemResponse.data.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
        }

        if (getItemResponse.data.length === 1) {
            await this.setState({
                items: getItemResponse.data
            });
            showAlert({ type: 'success', message: 'Se encontró artículo' });
            ReportsModel.ItemCode = getItemResponse.data[0].ItemCode;
            ReportsModel.ItemName = getItemResponse.data[0].ItemName;
            this.RefreshModel(ReportsModel);
        } else {
            await this.setState({
                items: getItemResponse.data.results,
                pageTotal: getItemResponse.data.totalPage
            });
            $('#itemsCreate').modal('show');
        }
    };

    SelectItems = async itemsSelected => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel } = this.state;
        if (itemsSelected.length > 1) {
            showAlert({ type: "info", message: 'Solo es posible seleccionar un artículo' });
            return;
        }
        enableSpinner(true);
        for (let index = 0; index < itemsSelected.length; index++) {
            const item = itemsSelected[index];
            ReportsModel.ItemCode = item.ItemCode;
            ReportsModel.ItemName = item.ItemName;
        }

        ReportsModel.searchItem = '';
        this.RefreshModel(ReportsModel);
        enableSpinner(false);
        setTimeout(() => {
            this.setState({
                items: [],
            });
        }, 100);

        $('#itemsCreate').modal('hide');
    };

    RefreshItems = async (item, totalRows) => {
        this.setState({
            items: item,
            pageTotal: totalRows
        });
    }

    GenerateReportKardex = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel } = this.state;

        if (ReportsModel.WhsCode === '---') {
            showAlert({ type: "info", message: 'Selecciona un almacén' });
            return;
        }

        if (ReportsModel.ItemCode === '') {
            showAlert({ type: "info", message: 'El código del artículo esta vacío' });
            return;
        }
        let separador = ReportsModel.WhsCode.split('|');

        ReportsModel.WhsCode = separador[0];

        enableSpinner(true);
        let data = {
            ReportsModel,
        }

        let responseGenerateReports = await apiClient.GenerateReportsKardex(data);

        if (responseGenerateReports.status !== 1) {
            showAlert({ type: "error", message: `${responseGenerateReports.message}` });
            enableSpinner(false);
            return;
        }

        if (!responseGenerateReports.data.flagResults) {
            showAlert({ type: "info", message: 'No se encontró información' });
            enableSpinner(false);
            return;
        }

        enableSpinner(false);
        await this.setState({
            ListReports: [responseGenerateReports.data] || [],
            ShowPDFViewerModal: !this.state.ShowPDFViewerModal
        });

        $("#pdfViewer").modal("show");
    };

    ChangePaymentType = event => {
        const { ReportsModel } = this.state;

        ReportsModel.PaymentType = event.nativeEvent.target.value;
        this.RefreshModel(ReportsModel);
    };

    ChangeActiveAmount = () => {
        const { ReportsModel } = this.state;

        ReportsModel.checkActiveAmount = !ReportsModel.checkActiveAmount;
        this.RefreshModel(ReportsModel);
    };

    ChangeCondition = event => {
        const { ReportsModel } = this.state;

        ReportsModel.Condition = event.nativeEvent.target.value;
        this.RefreshModel(ReportsModel);
    };

    ChangeAmount = event => {
        const { ReportsModel } = this.state;

        if (!isNaN(event.nativeEvent.target.value)) {
            ReportsModel.Amount = event.nativeEvent.target.value;
        }

        this.RefreshModel(ReportsModel);
    };

    GenerateReportCollect = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel } = this.state;

        if (ReportsModel.PaymentType === '---') {
            showAlert({ type: "info", message: 'Selecciona una forma de pago' });
            return;
        }
        if (ReportsModel.checkActiveAmount && ReportsModel.Amount === '') {
            showAlert({ type: "info", message: 'Escribe un monto' });
            return;
        }
        if (ReportsModel.checkActiveAmount && ReportsModel.Amount === '0') {
            showAlert({ type: "info", message: 'Escribe un monto mayor a 0' });
            return;
        }

        enableSpinner(true);
        let data = {
            ReportsModel,
        }

        let responseGenerateReports = await apiClient.GenerateReportsCollect(data);

        if (responseGenerateReports.status !== 1) {
            showAlert({ type: "error", message: `${responseGenerateReports.message}` });
            enableSpinner(false);
            return;
        }

        if (!responseGenerateReports.data.flagResults) {
            showAlert({ type: "info", message: 'No se encontró información' });
            enableSpinner(false);
            return;
        }

        enableSpinner(false);
        await this.setState({
            ListReports: [responseGenerateReports.data] || [],
            ShowPDFViewerModal: !this.state.ShowPDFViewerModal
        });

        $("#pdfViewer").modal("show");
    };

    toggleDocumentSelectedVendor = (id) => {
        const { ListEmployee } = this.state;
        let newEmployee = ListEmployee;
        newEmployee[id].selected = !newEmployee[id].selected;
        this.setState({
            ListEmployee: newEmployee,
        });
    };

    toggleDocumentSelectedAllVendor = async (action) => {
        const { ListEmployee, checkboxVendor } = this.state;
        let check = !checkboxVendor;
        for (let index = 0; index < ListEmployee.length; index++) {
            const element = ListEmployee[index];
            element.selected = check;
        }
        await this.setState({
            ListEmployee,
            checkboxVendor: check
        });
    };

    toggleDocumentSelectedLines = (id) => {
        const { ListItmsGrpCod } = this.state;
        let newItmsGrpCod = ListItmsGrpCod;
        newItmsGrpCod[id].selected = !newItmsGrpCod[id].selected;
        this.setState({
            ListItmsGrpCod: newItmsGrpCod
        });
    };

    toggleDocumentSelectedAllLines = async (action) => {
        const { ListItmsGrpCod, checkboxLines } = this.state;
        let check = !checkboxLines;
        for (let index = 0; index < ListItmsGrpCod.length; index++) {
            const element = ListItmsGrpCod[index];
            element.selected = check;
        }
        await this.setState({
            ListItmsGrpCod,
            checkboxLines: check
        });
    };

    GenerateReportOperationsVendor = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel, ListEmployee, ListItmsGrpCod } = this.state;

        let contadorEmployee = 0;
        let flagEmployee = false;
        let contadorLine = 0;
        let flagLine = false;

        for (let index = 0; index < ListEmployee.length; index++) {
            const element = ListEmployee[index];
            if (element.selected) {
                contadorEmployee += 1;
            }
        }
        for (let index = 0; index < ListItmsGrpCod.length; index++) {
            const element = ListItmsGrpCod[index];
            if (element.selected) {
                contadorLine += 1;
            }
        }


        if (ListEmployee.length === contadorEmployee) {
            flagEmployee = true;
        }
        if (ListItmsGrpCod.length === contadorLine) {
            flagLine = true;
        }
        enableSpinner(true);
        let data = {
            ReportsModel,
            ListEmployee,
            ListItmsGrpCod,
            flagEmployee,
            flagLine,
        }

        let responseGenerateReports = await apiClient.GenerateReportsOperationsVendor(data);

        if (responseGenerateReports.status !== 1) {
            showAlert({ type: "error", message: `${responseGenerateReports.message}` });
            enableSpinner(false);
            return;
        }

        if (!responseGenerateReports.data.flagResults) {
            showAlert({ type: "info", message: 'No se encontró información' });
            enableSpinner(false);
            return;
        }

        enableSpinner(false);
        await this.setState({
            ListReports: [responseGenerateReports.data] || [],
            ShowPDFViewerModal: !this.state.ShowPDFViewerModal
        });

        $("#pdfViewer").modal("show");
    };

    CleanReportModel = async () => {
        await this.setState({
            ReportsModel: new ReportsModel(),
        });
    }

    CloseReportSalesSellerModal = async () => {
        $("#reportSalesSellerModal").modal("hide");
    }

    CloseReportReserveInvoiceModal = async () => {
        $("#reportReserveInvoiceModal").modal("hide");
    }

    CloseReportItemsSoldsModal = async () => {
        $("#reportItemsSoldsModal").modal("hide");

    }

    CloseReportPurchasingModal = async () => {
        $("#reportPurchasingModal").modal("hide");

    }

    //#region  ##### REQUEST REPORT ############################################# ✔
    GetSellersReports = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel } = this.state;
        if (ReportsModel.Sucursal === '---') {
            showAlert({ type: "info", message: `SELECCIONA UNA SUCURSAL A CONSULTAR POR FAVOR` });
            return;
        }

        if (ReportsModel.checkCashNotes || ReportsModel.checkRefounds) {
            const data = {
                ReportsModel
            };
            enableSpinner(true);
            const responseApi = await apiClient.getSellersReports(data);
            enableSpinner(false);
            if (responseApi.status !== 1) {
                showAlert({ type: "error", message: `${responseApi.message}` });
                return;
            }
            if (!responseApi.data.flagResults) {
                showAlert({ type: "info", message: 'No se encontró información' });
                enableSpinner(false);
                return;
            }

            showAlert({ type: "success", message: `${responseApi.message}` });

            await this.setState({
                ListReports: [responseApi.data.responseData] || [],
                TypeDoc: 'BOSS',
                ShowPDFViewerModal: !this.state.ShowPDFViewerModal
            })
            $("#pdfViewer").modal("show");
        } else {
            showAlert({ type: "info", message: 'Selecciona un tipo de documento por favor.' });
            return;
        }
    }

    getDatesInRange(startDate, endDate) {
        const date = new Date(startDate);
        const dates = [];
        while (date <= endDate) {
            dates.push(new Date(date));
            date.setDate(date.getDate() + 1);
        }
        return dates;
    }

    GetSoldItemsByDate = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel } = this.state;
        if (ReportsModel.checkCashNotes || ReportsModel.checkRefounds) {
            const datesArray = await this.getDatesInRange(moment(ReportsModel.InitialDate).utc(), moment(ReportsModel.FinalDate).utc());
            const data = {
                ReportsModel,
                datesArray
            };
            enableSpinner(true);
            const responseApi = await apiClient.getSoldItemsByDate(data);
            enableSpinner(false);
            if (responseApi.status !== 1) {
                showAlert({ type: "error", message: `${responseApi.message}` });
                return;
            }
            if (!responseApi.data.flagResults) {
                showAlert({ type: "info", message: 'No se encontró información' });
                enableSpinner(false);
                return;
            }

            showAlert({ type: "success", message: `${responseApi.message}` });

            await this.setState({
                ListReports: [responseApi.data] || [],
                TypeDoc: 'SDBD',
                ShowPDFViewerModal: !this.state.ShowPDFViewerModal
            })
            $("#pdfViewer").modal("show");
        } else {
            showAlert({ type: "info", message: 'Selecciona un tipo de documento por favor.' });
            return;
        }

    }

    GetPurchasingDocs = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel } = this.state;
        if (ReportsModel.supplierEntries || ReportsModel.supplierInvoices || ReportsModel.supplierReturns || ReportsModel.supplierCreditNotes) {
            const data = {
                ReportsModel
            }

            enableSpinner(true);
            const responseApi = await apiClient.getPurchasingDocsReports(data);

            enableSpinner(false);
            if (responseApi.status !== 1) {
                showAlert({ type: "error", message: `${responseApi.message}` });
                return;
            }
            if (!responseApi.data.flagResults) {
                showAlert({ type: "info", message: 'No se encontró información' });
                enableSpinner(false);
                return;
            }
            showAlert({ type: "success", message: `${responseApi.message}` });

            await this.setState({
                ListReports: [responseApi.data] || [],
                TypeDoc: 'DOPU',
                ShowPDFViewerModal: !this.state.ShowPDFViewerModal,

            })
            $("#pdfViewer").modal("show");
        } else {
            showAlert({ type: "info", message: 'Selecciona un tipo de documento por favor.' });
            return;
        }
    }

    GenerateReportStocks = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel } = this.state;

        if (ReportsModel.WhsCode === '---') {
            showAlert({ type: "info", message: `Debes de seleccionar algún almacén` });
            return
        }
        if (ReportsModel.Filter === '---') {
            showAlert({ type: "info", message: `Debes de seleccionar tipo de filtro. (Linea o departamento)` });
            return
        }
        // if (!ReportsModel.checkExistNegative && !ReportsModel.checkExist) {
        //     showAlert({ type: "info", message: `Debes de seleccionar el tipo de existencia. (Existencia positiva o negativa)` });
        //     return
        // }

        // if ((ReportsModel.checkExistNegative || ReportsModel.checkExist) /*&& (  ReportsModel.checkExistDate ||  ReportsModel.checkInformationBatch)*/) {
        const data = {
            ReportsModel,
        }
        enableSpinner(true);
        const responseGenerateReports = await apiClient.GenerateReportsByStock(data);
        enableSpinner(false);
        if (responseGenerateReports.status !== 1) {
            showAlert({ type: "error", message: `${responseGenerateReports.message}` });

            return;
        }

        if (!responseGenerateReports.data.flagResults) {
            showAlert({ type: "info", message: 'No se encontró información' });
            enableSpinner(false);
            return;
        }

        this.setState({
            ListReports: [responseGenerateReports.data] || [],
            TypeDoc: 'ITMS',
            ShowPDFViewerModal: !this.state.ShowPDFViewerModal
        });

        $("#pdfViewer").modal("show");
        // } else {
        //     showAlert({ type: "info", message: 'Selecciona un tipo de operación, por lotes o por fecha' });
        //     return;
        // }
    };

    GetReserveInvoicesReport = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel } = this.state;
        if (ReportsModel.Sucursal === '---') {
            showAlert({ type: "info", message: `SELECCIONA UNA SUCURSAL A CONSULTAR POR FAVOR` });
            return;
        }
        // if (ReportsModel.User === '---') {
        //     showAlert({ type: "info", message: `SELECCIONA UN VENDEDOR POR FAVOR` });
        //     return;
        // }

        const data = {
            ReportsModel
        };
        enableSpinner(true);
        const responseApi = await apiClient.getReserveInvoicesReport(data);
        enableSpinner(false);
        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message}` });
            return;
        }

        showAlert({ type: "success", message: `${responseApi.message}` });

        await this.setState({
            ListReports: [responseApi.data] || [],
            TypeDoc: 'ReportInvoiceR',
            ShowPDFViewerModal: !this.state.ShowPDFViewerModal
        })
        $("#pdfViewer").modal("show");

    }

    // let avalibleProjects = await apiClient.getProjectsList();
    //#endregion

    //#region ########## MAIL FUNCTIONS  #################################################

    RefreshSendMailModel = (sendMailModel) => {
        this.setState({ sendMailModel })
    }

    SendDocsByEmail = async (docsStruct) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { sendMailModel, docsToPrint, typeDocPrint } = this.state
        // var value = docsStruct.innerHTML;
        // var objToSend = JSON.stringify(value);
        let infoFolio = await _generalFunctions.getDocInfoByFolio(docsToPrint[0].docHeader.infoByFolio.folio ?? '')
        sendMailModel.docEntry = infoFolio.DocEntry
        let data = {
            sendMailModel,
            // docsStruct: objToSend,
            typeDoc: typeDocPrint,
            objType: infoFolio.num,
            infoDoc: [{
                cardCode: docsToPrint[0].docHeader.responseHeader.CardCode ?? '',
                folio: docsToPrint[0].docHeader.infoByFolio.folio ?? '',
                slpInfo: {
                    slpCode: docsToPrint[0].docHeader ? docsToPrint[0].docHeader.responseHeader.SlpCode : docsToPrint[0].docHeader.SlpCode || '',
                    slpName: docsToPrint[0].docHeader ? docsToPrint[0].docHeader.responseHeader.SlpName : docsToPrint[0].docHeader.SlpName || '',
                }
            }]
        }

        enableSpinner(true);
        let responseApi = await apiClient.SendPrintDocsByEmail(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "error", message: `${responseApi.message ?? ''}` });
            return;
        }
        showAlert({ type: "success", message: `${responseApi.message ?? ''}` });
    }
    //#endregion

    //#region
    ChangeSucursal = async (event, option = false) => {
        const { ReportsModel } = this.state;
        ReportsModel.Sucursal = event.nativeEvent.target.value;
        ReportsModel.SucursalName = event.nativeEvent.target.options[event.target.selectedIndex].textContent;
        this.RefreshModel(ReportsModel);
        if (option) {
            await this.GetSellersByBOCode();
        }
    };
    //#endregion

    ShowFormatToPrint = async () => {
        await this.setState({
            printhide: !this.state.printhide,
        });
    };

    OpenReportCierreCaja = async () => {
        const { ReportsModel } = this.state;

        ReportsModel.InitialDate = this.state.ActualDate;
        ReportsModel.FinalDate = this.state.ActualDate;
        ReportsModel.Planta = '---';
        ReportsModel.Sucursal = '---';

        await this.setState({
            ReportsModel,
            ShowReportCierreCajaModal: !this.state.ShowReportCierreCajaModal
        });
        $("#reportCierreCajaModal").modal("show");
    };

    OpenReportContrasteCobranza = async () => {
        const { ReportsModel } = this.state;

        ReportsModel.InitialDate = this.state.ActualDate;
        ReportsModel.FinalDate = this.state.ActualDate;
        ReportsModel.Planta = '---';
        ReportsModel.Sucursal = '---';

        await this.setState({
            ReportsModel,
            ShowReportContrasteCobranzaModal: !this.state.ShowReportContrasteCobranzaModal
        });
        $("#reportContrasteCobranzaModal").modal("show");
    };

    GenerateReportCierreCaja = async (filters = {}) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel, sucursales, _user } = this.state;
        const isMaestra = Number(_user?.Branch?.Type) === 3;
        const sucursalUsuario = (sucursales || []).find(s => s.pk_Sucursal === Number(_user?.Branch?.IdBranch));
        const isPlanta = Number(sucursalUsuario?.Type) === 2;
        const isZonal = Number(sucursalUsuario?.Type) === 1;

        if (!filters.InitialDate || !filters.FinalDate) {
            return showAlert({ type: "warning", message: "Selecciona un rango de fechas" });
        }

        if (isMaestra && (!filters.Planta || filters.Planta === '---')) {
            return showAlert({ type: "warning", message: "Selecciona una planta" });
        }

        if (isPlanta && (!filters.Sucursal || filters.Sucursal === '---')) {
            return showAlert({ type: "warning", message: "Selecciona una zonal" });
        }

        const plantaObj = sucursales.find(s => s.pk_Sucursal === Number(filters.Planta));
        const sucursalObj = sucursales.find(s => s.pk_Sucursal === Number(filters.Sucursal));

        ReportsModel.NombrePlanta = plantaObj?.nombre || _user?.Branch?.BranchName || 'Todas';
        ReportsModel.NombreSucursal = sucursalObj?.nombre || 'Todas';

        enableSpinner(true);
        let reportResponse = await apiClient.GenerateCierreCajaReport(filters);
        enableSpinner(false);

        if (reportResponse.status !== 1) {
            return showAlert({ type: "error", message: reportResponse.message || "Error inesperado" });
        }

        if (!reportResponse.data.flagResults) {
            return showAlert({ type: "info", message: "No se encontró información" });
        }

        await this.setState({
            ReportsModel,
            ListReports: [reportResponse.data] || [],
            ShowPDFViewerModal: !this.state.ShowPDFViewerModal
        });
        $("#pdfViewer").modal("show");
    };

    GenerateReportContrasteCobranza = async (filters = {}) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel, sucursales, _user } = this.state;
        const isMaestra = Number(_user?.Branch?.Type) === 3;
        const sucursalUsuario = (sucursales || []).find(
            s => s.pk_Sucursal === Number(_user?.Branch?.IdBranch)
        );
        const isPlanta = Number(sucursalUsuario?.Type) === 2;
        const isZonal = Number(sucursalUsuario?.Type) === 1;

        if (!filters.InitialDate || !filters.FinalDate) {
            return showAlert({ type: "warning", message: "Selecciona un rango de fechas" });
        }

        if (isMaestra && (!filters.Planta || filters.Planta === '---')) {
            return showAlert({ type: "warning", message: "Selecciona una planta" });
        }

        if (isPlanta && (!filters.Sucursal || filters.Sucursal === '---')) {
            return showAlert({ type: "warning", message: "Selecciona una zonal" });
        }

        const plantaObj = sucursales.find(s => s.pk_Sucursal === Number(filters.Planta));
        const sucursalObj = sucursales.find(s => s.pk_Sucursal === Number(filters.Sucursal));

        ReportsModel.NombrePlanta = plantaObj?.nombre || _user?.Branch?.BranchName || 'Todas';
        ReportsModel.NombreSucursal = sucursalObj?.nombre || 'Todas';

        enableSpinner(true);
        let reportResponse = await apiClient.GenerateContrasteCobranzaReport(filters);
        enableSpinner(false);

        if (reportResponse.status !== 1) {
            return showAlert({ type: "error", message: reportResponse.message || "Error inesperado" });
        }

        if (!reportResponse.data.flagResults) {
            return showAlert({ type: "info", message: "No se encontró información" });
        }

        await this.setState({
            ReportsModel,
            ListReports: [reportResponse.data] || [],
            ShowPDFViewerModal: !this.state.ShowPDFViewerModal
        });
        $("#pdfViewer").modal("show");
    };

    ChangePayStatus = async (event) => {
        const { ReportsModel } = this.state;
        ReportsModel.PayStatus = event.nativeEvent.target.value;
        this.RefreshModel(ReportsModel);
    };

    ChangeDocType = async (event) => {
        const { ReportsModel } = this.state;
        ReportsModel.DocType = event.nativeEvent.target.value;
        this.RefreshModel(ReportsModel);
    };

    OpenReportEstatusFacturasModal = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { _user } = this.state;
        const data = { codeBO: _user?.Branch.CodeBranchOffice,};
        enableSpinner(true);
        const responseUsers = await apiClient.getSellersByBO(data);
        enableSpinner(false);

        if (responseUsers.status !== 1) {
            showAlert({ type: "error", message: `${responseUsers.message}` });
            return;
        }

        await this.setState({
            ListUsers: responseUsers.data || [],
            ShowReportEstatusFacturasModal: true
        });
        $("#reportEstatusFacturasModal").modal("show");
    };

    GenerateReportEstatusFacturas = async () => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { ReportsModel } = this.state;

        if (!ReportsModel.InitialDate || !ReportsModel.FinalDate) {
            showAlert({ type: "info", message: 'Selecciona un rango de fechas' });
            return;
        }

        enableSpinner(true);
        const data = { ReportsModel };
        let responseGenerateReports = await apiClient.generateEstatusFacturasReport(data);

        if (responseGenerateReports.status !== 1) {
            showAlert({ type: "error", message: `${responseGenerateReports.message}` });
            enableSpinner(false);
            return;
        }

        if (!responseGenerateReports.data.flagResults) {
            showAlert({ type: "info", message: 'No se encontró información' });
            enableSpinner(false);
            return;
        }

        enableSpinner(false);
        await this.setState({
            ListReports: [responseGenerateReports.data] || [],
            ShowPDFViewerModal: !this.state.ShowPDFViewerModal
        });
        $("#pdfViewer").modal("show");
    };

    SetFixedFilters = (sucursalId, userCode) => {
        const { ReportsModel, sucursales } = this.state;
        if (sucursalId != null) {
            ReportsModel.Sucursal = sucursalId;
            const found = (sucursales || []).find(
                s => Number(s.pk_Sucursal) === Number(sucursalId)
            );
            ReportsModel.SucursalName = found?.nombre || '';
        }

        if (userCode != null) {
            ReportsModel.User = userCode;
        }

        this.RefreshModel(ReportsModel);
    };

    render() {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;

        const {
            ReportsModel,
            ShowReportSalesModal,
            ActualDate,
            ListUsers,
            ListReports,
            ShowPDFViewerModal,
            ListWhsCodes,
            ListItmsGrpCod,
            ShowReportStocksModal,
            ShowReportCollectModal,
            ShowReportKardexModal,
            ShowReportOperationsModal,
            ShowReportSalesSellerModal,
            ShowReportItemsSoldsModal,
            ShowReportPurchasingModal,
            ListEmployee,
            partners,
            items,
            AvailablePayments,
            checkboxLines,
            checkboxVendor,
            TypeDoc,
            ListProjects,
            wareHouses,
            sendMailModel,
            sellersByBO,
            _user,
            sucursales,
            printhide,
            ShowReportReserveInvoiceModal,
            ShowGlobalInvoiceDeliveryReport,
            suggestionCatalogs,
            ShowReportReturnCNotes,
            showCreditWallet,
            showAccountStatus,
            showProductionTree,
            showProdOpenDocs,
            ShowReportContrasteCobranzaModal,
            ShowReportCierreCajaModal,
            ShowReportEstatusFacturasModal
        } = this.state;

        let EventCheckboxVendor = {
            selectOne: this.toggleDocumentSelectedVendor,
            selectAll: this.toggleDocumentSelectedAllVendor,
        }
        let EventCheckboxLines = {
            selectOne: this.toggleDocumentSelectedLines,
            selectAll: this.toggleDocumentSelectedAllLines,
        }
        const mailTools = {
            sendMailModel: sendMailModel,
            RefreshSendMailModel: this.RefreshSendMailModel,
            SendDocsByEmail: this.SendDocsByEmail
        }

        return (
            <div className="content">
                <NavBar props={this.props} logoCounter={true} _user={_user} />
                <TimeOut />
                <BreadCumb subitem1={'REPORTES'} url1={'#'} />
                <div className="mb-5" style={{ marginLeft: "4rem" }}>
                    <div>
                        <div className="row m-3"> <h3 className="ml-3 mb-2 mt-3">Reportes</h3> </div>
                        <div className="row m-3">
                            <ReportCard
                                title="Ventas"
                                action={this.OpenReportSalesModal} />
                            <ReportCard
                                title="Estatus de Facturas"
                                action={this.OpenReportEstatusFacturasModal} />
                            <ReportCard
                                title="Existencias"
                                action={this.OpenReportStockModal} />
                            <ReportCard
                                title="Cobranza"
                                action={this.OpenReportCollect} />
                            <ReportCard
                                title="Kardex"
                                action={this.OpenReportKardex} />
                            <ReportCard
                                title="Operaciones Vendedor"
                                action={this.OpenReportOperations} />
                            <ReportCard
                                title="Ventas Usuario"
                                action={this.OpenReportSalesSeller} />
                            <ReportCard
                                title="Artículos vendidos"
                                action={this.OpenReportItemsSolds} />
                            <ReportCard
                                title="Compras"
                                action={this.OpenReportPurchasing} />
                            <ReportCard
                                title="Facturas de reserva"
                                action={this.OpenReportReserveInvoiceModal} />
                            <ReportCard
                                title="Global Facturas/Entregas"
                                action={this.OpenGlobalInvoiceDeliveryReport} />
                            <ReportCard
                                title="Devoluciones y Notas de Crédito"
                                action={this.OpenReportReturnCNote} />
                            <ReportCard
                                title="Cartera de Crédito"
                                action={this.openReportCreditWallet} />
                            <ReportCard
                                title="Estado de cuenta"
                                action={this.openReportAccountStatus} />
                            <ReportCard
                                title="Lista de materiales"
                                action={this.openProductionTree} />
                            <ReportCard
                                title="Producción - Partidas abiertas"
                                action={this.openProdOpenDocs} />
                            {Modules['CierreCaja'] &&
                                <ReportCard title="Cierre de Caja" action={this.OpenReportCierreCaja} />
                            }
                            {Modules['ContrasteCobranza'] &&
                                <ReportCard title="Contraste Cobranza" action={this.OpenReportContrasteCobranza} />
                            }
                        </div>
                    </div>
                </div>

                {ShowReportSalesModal &&
                    <ReportSalesModal
                        ReportsModel={ReportsModel}
                        ChangeClient={this.ChangeClient}
                        cleanData={() => this.setState({ ShowReportSalesModal: false })}
                        ChangeInitialDate={this.ChangeInitialDate}
                        ChangeFinalDate={this.ChangeFinalDate}
                        ActualDate={ActualDate}
                        ChangeUser={this.ChangeUser}
                        ChangeType={this.ChangeType}
                        ListUsers={ListUsers}
                        ChangeViewEntries={this.ChangeViewEntries}
                        ChangeBill={this.ChangeBill}
                        ChangeCashNotes={this.ChangeCashNotes}
                        ChangeCreditNotes={this.ChangeCreditNotes}
                        ChangeRefounds={this.ChangeRefounds}
                        ChangeDirectDeliveries={this.ChangeDirectDeliveries}
                        GenerateReport={this.GenerateReport}
                        ListReports={ListReports}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ShowPDFViewer={this.ShowPDFViewer}
                        OpenPartnerModal={this.OpenPartnerModal}
                        partners={partners}
                        cleanDataPartners={() => this.setState({ partners: [] })}
                        SelectPartner={this.SelectPartner}
                        RefreshPartner={this.RefreshPartner}
                        MailTools={mailTools}
                        _user={_user}
                        sucursales={sucursales}
                        ChangeSucursal={this.ChangeSucursal}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                    />
                }

                {ShowReportEstatusFacturasModal &&
                    <ReportEstatusFacturasModal
                        ReportsModel={ReportsModel}
                        ChangeClient={this.ChangeClient}
                        cleanData={() => this.setState({ ShowReportEstatusFacturasModal: false })}
                        ChangeInitialDate={this.ChangeInitialDate}
                        ChangeFinalDate={this.ChangeFinalDate}
                        ActualDate={ActualDate}
                        ChangeUser={this.ChangeUser}
                        ChangeType={this.ChangeType}
                        ChangeStatus={this.ChangeStatus}
                        ChangePayStatus={this.ChangePayStatus}
                        ChangeDocType={this.ChangeDocType}
                        ListUsers={ListUsers}
                        GenerateReport={this.GenerateReportEstatusFacturas}
                        ListReports={ListReports}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ShowPDFViewer={this.ShowPDFViewer}
                        OpenPartnerModal={this.OpenPartnerModal}
                        partners={partners}
                        cleanDataPartners={() => this.setState({ partners: [] })}
                        SelectPartner={this.SelectPartner}
                        RefreshPartner={this.RefreshPartner}
                        MailTools={mailTools}
                        _user={_user}
                        sucursales={sucursales}
                        ChangeSucursal={this.ChangeSucursal}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                        SetFixedFilters={this.SetFixedFilters}
                    />
                }

                {ShowReportStocksModal &&
                    <ReportStocksModal
                        ReportsModel={ReportsModel}
                        ListProjects={ListProjects}
                        wareHouses={wareHouses}
                        ListItmsGrpCod={ListItmsGrpCod}
                        ListReports={ListReports}
                        ActualDate={ActualDate}
                        cleanData={() => this.setState({ ShowReportStocksModal: false })}
                        ChangeWhsCode={this.ChangeWhsCode}
                        ChangeWhsCodeBySelect={this.ChangeWhsCodeBySelect}
                        ChangeFilter={this.ChangeFilter}
                        ChangeLine={this.ChangeLine}
                        ChangeCheckExistDate={this.ChangeCheckExistDate}
                        ChangeCheckExistNegative={this.ChangeCheckExistNegative}
                        ChangeCheckInformationBatch={this.ChangeCheckInformationBatch}
                        ChangeCheckExist={this.ChangeCheckExist}
                        ChangeInitialDate={this.ChangeInitialDate}
                        GenerateReportStocks={this.GenerateReportStocks}
                        ShowPDFViewer={this.ShowPDFViewer}
                        CleanReportModel={this.CleanReportModel}
                        TypeDoc={TypeDoc}
                        MailTools={mailTools}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                    />
                }

                {ShowReportCollectModal &&
                    <ReportCollectModal
                        cleanData={() => this.setState({ ShowReportCollectModal: false })}
                        ReportsModel={ReportsModel}
                        ChangeInitialDate={this.ChangeInitialDate}
                        ChangeFinalDate={this.ChangeFinalDate}
                        ActualDate={ActualDate}
                        ChangePaymentType={this.ChangePaymentType}
                        ChangeActiveAmount={this.ChangeActiveAmount}
                        ChangeCondition={this.ChangeCondition}
                        ChangeAmount={this.ChangeAmount}
                        GenerateReportCollect={this.GenerateReportCollect}
                        AvailablePayments={AvailablePayments}
                        ListReports={ListReports}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ShowPDFViewer={this.ShowPDFViewer}
                        MailTools={mailTools}
                        _user={_user}
                        sucursales={sucursales}
                        ChangeSucursal={this.ChangeSucursal}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                    />
                }

                {ShowReportKardexModal &&
                    <ReportKardexModal
                        ReportsModel={ReportsModel}
                        ListWhsCodes={ListWhsCodes}
                        ChangeWhsCode={this.ChangeWhsCode}
                        cleanData={() => this.setState({ ShowReportKardexModal: false })}
                        ActualDate={ActualDate}
                        ChangeInitialDate={this.ChangeInitialDate}
                        ChangeFinalDate={this.ChangeFinalDate}
                        ChangeItemCode={this.ChangeItemCode}
                        OpenItems={this.OpenItems}
                        items={items}
                        ClenDataItems={() => this.setState({ items: [] })}
                        SelectItems={this.SelectItems}
                        RefreshItems={this.RefreshItems}
                        GenerateReportKardex={this.GenerateReportKardex}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ListReports={ListReports}
                        ShowPDFViewer={this.ShowPDFViewer}
                        MailTools={mailTools}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                    />
                }

                {ShowReportOperationsModal &&
                    <ReportOperationsModal
                        cleanData={() => this.setState({ ShowReportOperationsModal: false })}
                        ReportsModel={ReportsModel}
                        ActualDate={ActualDate}
                        ChangeInitialDate={this.ChangeInitialDate}
                        ChangeFinalDate={this.ChangeFinalDate}
                        ListEmployee={ListEmployee}
                        ListItmsGrpCod={ListItmsGrpCod}
                        ChangeCondition={this.ChangeCondition}
                        ChangeAmount={this.ChangeAmount}
                        EventCheckboxVendor={EventCheckboxVendor}
                        EventCheckboxLines={EventCheckboxLines}
                        GenerateReportOperationsVendor={this.GenerateReportOperationsVendor}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ListReports={ListReports}
                        ShowPDFViewer={this.ShowPDFViewer}
                        checkboxLines={checkboxLines}
                        checkboxVendor={checkboxVendor}
                        MailTools={mailTools}
                        _user={_user}
                        sucursales={sucursales}
                        ChangeSucursal={this.ChangeSucursal}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                    />
                }

                {ShowReportSalesSellerModal &&
                    <ReportSalesSellerModal
                        cleanData={() => this.setState({ ShowReportSalesSellerModal: false })}
                        ReportsModel={ReportsModel}
                        ActualDate={ActualDate}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ListReports={ListReports}
                        TypeDoc={TypeDoc}
                        ChangeInitialDate={this.ChangeInitialDate}
                        ChangeFinalDate={this.ChangeFinalDate}
                        ChangeRefounds={this.ChangeRefounds}
                        ChangeCashNotes={this.ChangeCashNotes}
                        GetSellersReports={this.GetSellersReports}
                        CleanReportModel={this.CleanReportModel}
                        CloseReportSalesSellerModal={this.CloseReportSalesSellerModal}
                        ShowPDFViewer={this.ShowPDFViewer}
                        MailTools={mailTools}
                        sellersByBO={sellersByBO}
                        ChangeUser={this.ChangeUser}
                        _user={_user}
                        sucursales={sucursales}
                        ChangeSucursal={this.ChangeSucursal}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                    />
                }

                {ShowReportItemsSoldsModal &&
                    <ReportItemsSoldsModal
                        cleanData={() => this.setState({ ShowReportItemsSoldsModal: false })}
                        ReportsModel={ReportsModel}
                        ActualDate={ActualDate}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ListReports={ListReports}
                        TypeDoc={TypeDoc}
                        ChangeInitialDate={this.ChangeInitialDate}
                        ChangeFinalDate={this.ChangeFinalDate}
                        ChangeCashNotes={this.ChangeCashNotes}
                        ChangeRefounds={this.ChangeRefounds}
                        GetSoldItemsByDate={this.GetSoldItemsByDate}
                        ShowPDFViewer={this.ShowPDFViewer}
                        CleanReportModel={this.CleanReportModel}
                        CloseReportItemsSoldsModal={this.CloseReportItemsSoldsModal}
                        MailTools={mailTools}
                        _user={_user}
                        sucursales={sucursales}
                        ChangeSucursal={this.ChangeSucursal}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                    />
                }

                {ShowReportPurchasingModal &&
                    <ReportPurchasingModal
                        cleanData={() => this.setState({ ShowReportPurchasingModal: false })}
                        ReportsModel={ReportsModel}
                        ActualDate={ActualDate}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ListReports={ListReports}
                        TypeDoc={TypeDoc}
                        ChangeType={this.ChangeType}
                        ChangeInitialDate={this.ChangeInitialDate}
                        ChangeFinalDate={this.ChangeFinalDate}
                        ChangeSupplierEntries={this.ChangeSupplierEntries}
                        ChangeSupplierInvoices={this.ChangeSupplierInvoices}
                        ChangeSupplierReturns={this.ChangeSupplierReturns}
                        ChangeSupplierCreditNotes={this.ChangeSupplierCreditNotes}
                        ChangeSupplierDocPayCondition={this.ChangeSupplierDocPayCondition}
                        ShowPDFViewer={this.ShowPDFViewer}
                        CleanReportModel={this.CleanReportModel}
                        CloseReportPurchasingModal={this.CloseReportPurchasingModal}
                        GetPurchasingDocs={this.GetPurchasingDocs}
                        MailTools={mailTools}
                        _user={_user}
                        sucursales={sucursales}
                        ChangeSucursal={this.ChangeSucursal}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                    />
                }

                {ShowReportReserveInvoiceModal &&
                    <ReportReserveInvoiceModal
                        cleanData={() => this.setState({ ShowReportReserveInvoiceModal: false })}
                        ReportsModel={ReportsModel}
                        ActualDate={ActualDate}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ListReports={ListReports}
                        TypeDoc={TypeDoc}
                        ChangeInitialDate={this.ChangeInitialDate}
                        ChangeFinalDate={this.ChangeFinalDate}
                        ChangeRefounds={this.ChangeRefounds}
                        ChangeCashNotes={this.ChangeCashNotes}
                        GetReserveInvoicesReport={this.GetReserveInvoicesReport}
                        CleanReportModel={this.CleanReportModel}
                        CloseReportReserveInvoiceModal={this.CloseReportReserveInvoiceModal}
                        ShowPDFViewer={this.ShowPDFViewer}
                        MailTools={mailTools}
                        sellersByBO={sellersByBO}
                        ChangeStatus={this.ChangeStatus}
                        _user={_user}
                        sucursales={sucursales}
                        ChangeSucursal={this.ChangeSucursal}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                    />
                }

                {ShowGlobalInvoiceDeliveryReport &&
                    <ReportGlobalInvoiceDeliveryModal
                        ReportsModel={ReportsModel}
                        ChangeClient={this.ChangeClient}
                        cleanData={() => this.setState({ ShowGlobalInvoiceDeliveryReport: false })}
                        ChangeInitialDate={this.ChangeInitialDate}
                        ChangeFinalDate={this.ChangeFinalDate}
                        ActualDate={ActualDate}
                        ChangeUser={this.ChangeUser}
                        ChangeType={this.ChangeType}
                        ListUsers={ListUsers}
                        ChangeViewEntries={this.ChangeViewEntries}
                        ChangeBill={this.ChangeBill}
                        ChangeCashNotes={this.ChangeCashNotes}
                        ChangeCreditNotes={this.ChangeCreditNotes}
                        ChangeRefounds={this.ChangeRefounds}
                        ChangeDirectDeliveries={this.ChangeDirectDeliveries}
                        GenerateReport={this.GenerateReportGlobalInvoiceDelivery}
                        ListReports={ListReports}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ShowPDFViewer={this.ShowPDFViewer}
                        OpenPartnerModal={this.OpenPartnerModal}
                        partners={partners}
                        cleanDataPartners={() => this.setState({ partners: [] })}
                        SelectPartner={this.SelectPartner}
                        RefreshPartner={this.RefreshPartner}
                        MailTools={mailTools}
                        _user={_user}
                        sucursales={sucursales}
                        ChangeSucursal={this.ChangeSucursal}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                    />
                }

                {ShowReportReturnCNotes &&
                    <ReportReturnCNoteModal
                        ReportsModel={ReportsModel}
                        ChangeClient={this.ChangeClient}
                        cleanData={() => this.setState({ ReportReturnCNoteModal: false })}
                        ChangeInitialDate={this.ChangeInitialDate}
                        ChangeFinalDate={this.ChangeFinalDate}
                        ActualDate={ActualDate}
                        ChangeUser={this.ChangeUser}
                        ChangeType={this.ChangeType}
                        ChangeCNote={this.ChangeCNote}
                        ChangeReturn={this.ChangeReturn}
                        ListUsers={ListUsers}
                        ChangeViewEntries={this.ChangeViewEntries}
                        GenerateReport={this.GenerateReportGlobalInvoiceDelivery}
                        ListReports={ListReports}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ShowPDFViewer={this.ShowPDFViewer}
                        OpenPartnerModal={this.OpenPartnerModal}
                        partners={partners}
                        cleanDataPartners={() => this.setState({ partners: [] })}
                        SelectPartner={this.SelectPartner}
                        RefreshPartner={this.RefreshPartner}
                        MailTools={mailTools}
                        _user={_user}
                        sucursales={sucursales}
                        ChangeSucursal={this.ChangeSucursal}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                    />
                }

                {showCreditWallet &&
                    <ReportCreditWalletModal
                        branchOffices={sucursales}
                        suggestionCatalogs={suggestionCatalogs}

                        // Standard Props
                        GenerateReport={this.GenerateCreditWalletReport}
                        ListReports={ListReports}
                        ReportsModel={ReportsModel}
                        MailTools={mailTools}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ShowPDFViewer={this.ShowPDFViewer}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint} />
                }

                {showAccountStatus &&
                    <ReportAccountStatusModal
                        branchOffices={sucursales}
                        suggestionCatalogs={suggestionCatalogs}

                        // Standard Props
                        GenerateReport={this.GenerateAccountStatusReport}
                        ListReports={ListReports}
                        ReportsModel={ReportsModel}
                        MailTools={mailTools}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ShowPDFViewer={this.ShowPDFViewer}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint} />
                }

                {showProductionTree &&
                    <ReportProductionTree
                        ListItmsGrpCod={ListItmsGrpCod}

                        // Standard Props
                        showAlert={showAlert}
                        GenerateReport={this.GenerateReportsProduction}
                        ListReports={ListReports}
                        ReportsModel={ReportsModel}
                        MailTools={mailTools}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ShowPDFViewer={this.ShowPDFViewer}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint} />
                }

                {showProdOpenDocs &&
                    <ReportProdOpenDocs
                        // Standard Props
                        showAlert={showAlert}
                        GenerateReport={this.GenerateReportsProduction}
                        ListReports={ListReports}
                        ReportsModel={ReportsModel}
                        MailTools={mailTools}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ShowPDFViewer={this.ShowPDFViewer}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint} />
                }

                {ShowReportCierreCajaModal &&
                    <ReportCierreCajaModal
                        cleanData={() => this.setState({ ShowReportCierreCajaModal: false })}
                        ReportsModel={ReportsModel}
                        ActualDate={ActualDate}
                        ChangeInitialDate={this.ChangeInitialDate}
                        ChangeFinalDate={this.ChangeFinalDate}
                        GenerateReport={this.GenerateReportCierreCaja}
                        ListReports={ListReports}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ShowPDFViewer={this.ShowPDFViewer}
                        MailTools={mailTools}
                        _user={_user}
                        sucursales={sucursales}
                        ChangeSucursal={this.ChangeSucursal}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                    />
                }

                {ShowReportContrasteCobranzaModal &&
                    <ReportContrasteCobranzaModal
                        cleanData={() => this.setState({ ShowReportContrasteCobranzaModal: false })}
                        ReportsModel={ReportsModel}
                        ActualDate={ActualDate}
                        ChangeInitialDate={this.ChangeInitialDate}
                        ChangeFinalDate={this.ChangeFinalDate}
                        GenerateReport={this.GenerateReportContrasteCobranza}
                        ListReports={ListReports}
                        ShowPDFViewerModal={ShowPDFViewerModal}
                        ShowPDFViewer={this.ShowPDFViewer}
                        MailTools={mailTools}
                        _user={_user}
                        sucursales={sucursales}
                        ChangeSucursal={this.ChangeSucursal}
                        printhide={printhide}
                        ShowFormatToPrint={this.ShowFormatToPrint}
                    />
                }
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportSalesView);